/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeALeftIcon16Solid = forwardRef('ArrowShapeALeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.603 9.413a2 2 0 0 1 0-2.828L7.293.896C7.923.266 9 .713 9 1.604V4h4.25c.966 0 1.75.784 1.75 1.75v4.5A1.75 1.75 0 0 1 13.25 12H9v2.396c0 .891-1.077 1.337-1.707.707l-5.69-5.69Z" })));
});
